import React from 'react';
interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}
const BaseIcon = ({
  children,
  size = 24,
  className = '',
  ...props
}: IconProps & {
  children: React.ReactNode;
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-47">
    {children}
  </svg>;
export const LeafIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-48">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-49" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-50" />
  </BaseIcon>;
export const FlameIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-51">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" data-id="element-52" />
  </BaseIcon>;
export const BedIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-53">
    <path d="M2 4v16" data-id="element-54" />
    <path d="M2 8h18a2 2 0 0 1 2 2v10" data-id="element-55" />
    <path d="M2 17h20" data-id="element-56" />
    <path d="M6 8v9" data-id="element-57" />
  </BaseIcon>;
export const UtensilsIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-58">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" data-id="element-59" />
    <path d="M7 2v20" data-id="element-60" />
    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" data-id="element-61" />
  </BaseIcon>;
export const MountainIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-62">
    <path d="m8 3 4 8 5-5 5 15H2L8 3z" data-id="element-63" />
  </BaseIcon>;
export const StarsIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-64">
    <path d="M12 3v18" data-id="element-65" />
    <path d="M3 12h18" data-id="element-66" />
    <path d="m18.364 5.636-12.728 12.728" data-id="element-67" />
    <path d="m5.636 5.636 12.728 12.728" data-id="element-68" />
  </BaseIcon>;
export const BookIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-69">
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" data-id="element-70" />
  </BaseIcon>;
export const ArchwayIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-71">
    <path d="M4 22V10a8 8 0 1 1 16 0v12" data-id="element-72" />
    <path d="M4 10h16" data-id="element-73" />
  </BaseIcon>;
export const WaterDropIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-74">
    <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" data-id="element-75" />
  </BaseIcon>;
export const TreeIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-76">
    <path d="M12 22v-8" data-id="element-77" />
    <path d="m8 14 4-4 4 4" data-id="element-78" />
    <path d="m9 10 3-3 3 3" data-id="element-79" />
    <path d="m10 6 2-2 2 2" data-id="element-80" />
  </BaseIcon>;
export const SunIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-81">
    <circle cx="12" cy="12" r="4" data-id="element-82" />
    <path d="M12 2v2" data-id="element-83" />
    <path d="M12 20v2" data-id="element-84" />
    <path d="m4.93 4.93 1.41 1.41" data-id="element-85" />
    <path d="m17.66 17.66 1.41 1.41" data-id="element-86" />
    <path d="M2 12h2" data-id="element-87" />
    <path d="M20 12h2" data-id="element-88" />
    <path d="m6.34 17.66-1.41 1.41" data-id="element-89" />
    <path d="m19.07 4.93-1.41 1.41" data-id="element-90" />
  </BaseIcon>;
export const MoonIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-91">
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-92" />
  </BaseIcon>;
export const PhoneIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-93">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-94" />
  </BaseIcon>;
export const EnvelopeIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-95">
    <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-96" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-97" />
  </BaseIcon>;
export const CheckIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-98">
    <path d="M20 6 9 17l-5-5" data-id="element-99" />
  </BaseIcon>;
export const HomeIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-100">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" data-id="element-101" />
    <polyline points="9 22 9 12 15 12 15 22" data-id="element-102" />
  </BaseIcon>;
export const BuildingIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-103">
    <rect width="16" height="20" x="4" y="2" rx="2" ry="2" data-id="element-104" />
    <path d="M9 22v-4h6v4" data-id="element-105" />
    <path d="M8 6h.01" data-id="element-106" />
    <path d="M16 6h.01" data-id="element-107" />
    <path d="M12 6h.01" data-id="element-108" />
    <path d="M12 10h.01" data-id="element-109" />
    <path d="M12 14h.01" data-id="element-110" />
    <path d="M16 10h.01" data-id="element-111" />
    <path d="M16 14h.01" data-id="element-112" />
    <path d="M8 10h.01" data-id="element-113" />
    <path d="M8 14h.01" data-id="element-114" />
  </BaseIcon>;
export const WarningIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-115">
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" data-id="element-116" />
    <path d="M12 9v4" data-id="element-117" />
    <path d="M12 17h.01" data-id="element-118" />
  </BaseIcon>;
export const CircleIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-119">
    <circle cx="12" cy="12" r="10" data-id="element-120" />
  </BaseIcon>;
export const CircleCheckIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-121">
    <circle cx="12" cy="12" r="10" data-id="element-122" />
    <path d="m9 12 2 2 4-4" data-id="element-123" />
  </BaseIcon>;
export const CircleXIcon = (props: IconProps) => <BaseIcon {...props} data-id="element-124">
    <circle cx="12" cy="12" r="10" data-id="element-125" />
    <path d="m15 9-6 6" data-id="element-126" />
    <path d="m9 9 6 6" data-id="element-127" />
  </BaseIcon>;